import {Component, Input, OnChanges, OnInit, SimpleChanges} from '@angular/core';
import * as moment from 'moment';
import {ApiService, Room, SiteInfosService, WindowRefService} from '@app/core';

@Component({
    selector: 'app-resa-info',
    templateUrl: './resa-info.component.html',
    styleUrls: ['./resa-info.component.scss']
})
export class ResaInfoComponent implements OnInit {

    constructor(public siteInfo: SiteInfosService, public winRef: WindowRefService) {}

    @Input('resaInfo') infos : any;
    @Input('roomsInfo') roomsInfo : Array<any>;
    ngOnInit() {

    }

    get startDate(): String {
      return moment(this.infos.rDateFrom).format('dddd, DD MMMM YYYY');
    }

    get endDate(): String {
      return moment(this.infos.rDateTo).format('dddd, DD MMMM YYYY');
    }

    /**
     * get taux de change
     * @returns number
     */
    get Cpercente(): number {
      return this.winRef.appConfigSite.Cpercente;
    }

    /**
     * get currency
     * @returns string
     */
    get Ccurrency(): string {
      return this.winRef.appConfigSite.Ccurrency;
    }

    /**
     * lang
     * @returns string lang
     */
    get lang(): string {
      return this.winRef.appConfigSite.defaultlangue
    }
}
